import React, { Component } from 'react';
import { Button, HeaderName, HeaderNavigation, SkeletonText, Tag } from 'carbon-components-react';
import { CompletionStatusTag } from '../components/functions/CompletionStatusTag';
import { ChevronLeft16 } from '@carbon/icons-react';
import { Link } from 'react-router-dom';

export default function PageBreadCrumb(props) {
  const {
    linkTo,
    linkText,
    titleLeft,
    titleCenter,
    titleRight,
    batchActions,
    showButtonHistory,
    isDisabled,
    showCurrentVersion, //A1_CTRL_F5_Issue_After_New_Deploy
  } = props;
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };
  return (
    <div className={isDisabled ? 'disableBreadcrumb' : null}>
      <div
        className={
          batchActions != null || showButtonHistory
            ? 'pageBreadCrumb pageBreadCrumb-action'
            : ' pageBreadCrumb pageBreadCrumb-no_action'
        }
      >
        <Link
          to={props.onClick ? '#' : linkTo || '/'}
          onClick={() => handleClick()}
          className="bx--header__name"
        >
          <ChevronLeft16 fill="#e16e08" className="arraw-back" />
          <h5 className="text-back">{linkText || ''}</h5>
        </Link>
        <div className="page-breadcrumb">
          <HeaderNavigation className="headerNavigation-description " aria-label="">
            <>
              <li className="breadcrumb-section">
                <h4 className="title-left">{titleLeft || ''}</h4>
                <h4 className="title-left">{titleCenter || ''}</h4>
                <div className="pageSubBreadCrumb-tag ">
                  {Array.isArray(titleRight) ? (
                    <>
                      <StatusTag value={titleRight[0]} />
                      {titleRight[1] ? <CompletionStatusTag value={titleRight[1]} /> : null}
                    </>
                  ) : (
                    <StatusTag value={titleRight} />
                  )}
                </div>
              </li>
              {/* A1_CTRL_F5_Issue_After_New_Deploy */}
              {showCurrentVersion ? (
                <>
                {showCurrentVersion}
                </>
                ) : (
                  ''
                )}
              {/* End */}
            </>
          </HeaderNavigation>
        </div>
      </div>
      {batchActions != null || showButtonHistory ? (
        <div className="pageSubBreadCrumb pageSubBreadCrumb-action ">
          <div className="pageSubBreadCrumb-tag-mobile   ">
            {Array.isArray(titleRight) ? (
              <>
                <StatusTag value={titleRight[0]} />
                {titleRight[1] ? <CompletionStatusTag value={titleRight[1]} /> : null}
              </>
            ) : (
              <StatusTag value={titleRight} />
            )}
          </div>

          <div className="page-breadcrumb">
            <HeaderNavigation className="headerNavigation-description " aria-label="">
              <>
                {batchActions && (
                  <li className="batch-actions breadcrumb-section">{batchActions}</li>
                )}
                {showButtonHistory}
              </>
            </HeaderNavigation>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
export function StatusTag(props) {
  const value = props.value;
  if (!value) return null;

  switch (value.toLowerCase()) {
    case '1':
    case 'draft':
    case 'opened':
    case 'assigned':
    case 'insert':
      return (
        <Tag className="auditTag" type="green" disabled={false} role="listitem">
          {value}
        </Tag>
      );
    case 'dev':
    case 'insert':
      return (
        <Tag className="env-title" type="green" disabled={false} role="listitem">
          {value}
        </Tag>
      );
    case '2':
    case 'submitted':
      return (
        <Tag className="auditTag" type="purple" disabled={false} role="listitem">
          {value}
        </Tag>
      );
    case '3':
    case 'approved':
    case 'update':
      return (
        <Tag className="auditTag" type="blue" disabled={false} role="listitem">
          {value}
        </Tag>
      );
    case '4':
    case 'consolidated':
    case 'planned':
    case 'completed':
    case 'closed':
    case 'delete':
      return (
        <Tag className="auditTag" type="red" disabled={false} role="listitem">
          {value}
        </Tag>
      );
      // RITM0623664
    case 'ext-draft':
    case 'ext-planned':
      const isDraft = value.toLowerCase().includes("draft")
      return (
      <Tag className="auditTag" type={isDraft ? "green" : "red"} disabled={false} role="listitem">
        Ext
      </Tag>
      );
      //FINE  RITM0623664
    case 'drillplanned':
    case 'drillcompleted':
      const ret1 = value.replace('drill','')
      return (
      <Tag className="auditTag" type="green" disabled={false} role="listitem">
        {ret1}
      </Tag>
      );
      case 'drilldraft':
      case 'drillopened':
        const ret2 = value.replace('drill','')
        return (
        <Tag className="auditTag" type="red" disabled={false} role="listitem">
          {ret2}
        </Tag>
        );
      case 'drillsubmitted':
        const ret3 = value.replace('drill','')
        return (
        <Tag className="auditTagOrange" type="red" disabled={false} role="listitem">
          {ret3}
        </Tag>
          );
      case 'drillapproved':
          const ret4 = value.replace('drill', '')
          return (
              <Tag className="auditTag" type="blue" disabled={false} role="listitem">
                  {ret4}
              </Tag>
          );
    default:
      return (
        <Tag className="auditTag" type="warm-gray" disabled={false} role="listitem">
          {value}
        </Tag>
      );
  }
}
